import { P0, S, abs, arc, fillAt, max, rotPts } from '../../geometry';

export const chick = {
  name: 'Chick',
  colors: ['#E3A008', '#C46A3E'],
  draw(m, t) {
    let fl = 4 * S(t * 2),
      sw = 2 * S(t * 1.4),
      tall = 1,
      pose = P0();
    if (m === 'happy') {
      fl = 28 * abs(S(t * 14));
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: head tilts, the tuft sways and the wings tap.
    if (m === 'thinking') {
      pose.rot = 6 * S(t * 1.3);
      sw = 6 * S(t * 2.6);
      fl = 12 * S(t * 2.6);
    }
    if (m === 'talking') fl = 12 * max(0, S(t * 10));
    if (m === 'surprised') {
      fl = 38;
      tall = 1.4;
      sw = 0;
    }
    if (m === 'paused') {
      fl = -4;
      sw = -7;
      tall = 0.7;
      pose.sy = 0.92;
      pose.ty = 2;
    }
    const wing = [
      [27, 53],
      [16, 60],
      [20, 71],
    ];
    return {
      strokes: [
        { c: 'a', pts: arc(50, 58, 25, -90, 270, 17), n: 26 },
        {
          c: 'b',
          pts: [
            [49, 34],
            [47 + sw * 0.6, 34 - 7 * tall],
            [43 + sw, 32 - 11 * tall],
          ],
        },
        {
          c: 'b',
          pts: [
            [51, 34],
            [55 + sw * 0.6, 34 - 8 * tall],
            [59 + sw, 33 - 12 * tall],
          ],
        },
        { c: 'a', pts: rotPts(wing, 27, 56, fl) },
        {
          c: 'a',
          pts: rotPts(
            wing.map(([x, y]) => [100 - x, y]),
            73,
            56,
            -fl
          ),
        },
        {
          c: 'b',
          pts: [
            [43, 84],
            [43, 90],
          ],
        },
        {
          c: 'b',
          pts: [
            [57, 84],
            [57, 90],
          ],
        },
      ],
      eyes: { x: 50, y: 57 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
